import React from "react";
import { IoIosStar, IoIosStarHalf } from "react-icons/io";

const StarRating = (props) => {
    const color = props.color ? props.color : '#307FE2';
    const size = props.size ? props.size : 18;

    if (props.stars <= 0 || props.stars == null || props.stars === "") {
        return <></>
    }
    const numericStars = Number(props.stars);

    if (!Number.isFinite(numericStars) || numericStars <= 0) {
        return <></>;
    }

    const normalizedStars = Math.min(5, Math.round(numericStars * 2) / 2);
    const fullStars = Math.floor(normalizedStars);
    const hasHalfStar = normalizedStars % 1 !== 0;

    return (
        <div style={{ display: 'flex', textAlign: 'center' }} {...props}>
            {Array.from({ length: fullStars }).map((_, index) => (
                <IoIosStar key={`full-${index}`} size={size} color={color} />
            ))}
            {hasHalfStar && <IoIosStarHalf key="half" size={size} color={color} />}
        </div>
    );
};



export default StarRating;
